import { ACTIVITY_TYPES } from '../../../shared/types/social'
import type { PageComponent } from '../../router'
import { ActivityPageController } from './ActivityPageController'
import { activityPageTemplate } from './activityPageTemplates'

const ActivityPage: PageComponent = {
	async mount(context) {
		const { containerEl, user, signal } = context
		if (!user) throw new Error('Authentication required')
		containerEl.innerHTML = activityPageTemplate([...ACTIVITY_TYPES])
		const root = containerEl.querySelector<HTMLElement>('#activity-section')
		if (!root) throw new Error('Missing activity page')
		const controller = new ActivityPageController(root, user._id)
		signal.addEventListener('abort', () => controller.dispose(), {
			once: true,
		})
		await controller.ready
		signal.throwIfAborted()
		return controller
	},
}
export default ActivityPage
